import React from 'react';

import {
    ChecklistIcon,
    DiamondIcon,
    OdometerIcon,
} from '@iris/react-icons';

/**
 * Maps spec keys to their corresponding icons
 * @param {string} specKey - The spec key
 * @returns {React.Element|null} The corresponding icon component or null
 */
export function getSpecIcon(specKey) {
    const iconMap = {
        mileage: <OdometerIcon />,
        windowSticker: <ChecklistIcon />,
        inspectionReport: <ChecklistIcon />,
        // All differentiators use diamond icon
        differentiators: <DiamondIcon />,
    };

    return iconMap[specKey] || null;
}

/**
 * Set of spec keys that should be treated as differentiators
 */
export const differentiators = new Set(['lowMileage', 'wellEquipped', 'vehicleReconditioning', 'differentiators']);

/**
 * Checks if a spec key is a differentiator
 * @param {string} specKey - The spec key to check
 * @returns {boolean} True if the spec key is a differentiator
 */
export function isDifferentiator(specKey) {
    const differentiatorKeys = new Set([
        'lowMileage',
        'wellEquipped',
        'vehicleReconditioning',
        'differentiators',
    ]);

    return differentiatorKeys.has(specKey);
}
